module.exports = __webpack_public_path__ + "img/fill-warning.8ec03232.svg";